<ll-toolnavbar>
    <materiales-toolnavbar></materiales-toolnavbar>
</ll-toolnavbar>
<ll-titulo>Aplicación</ll-titulo>
<ll-subtitulo>{{ material?.material }}</ll-subtitulo>
<materiales-apps (onReady)="onReady($event)"></materiales-apps>
